import api from './api';
import {
  Trigger,
  TriggerAssetScope,
  TriggerAssignmentStrategy,
  PaginatedResponse,
} from '../types';

export interface TriggerFilters {
  search?: string;
  eventDefinitionId?: string;
  isActive?: boolean;
}

export interface CreateTriggerRequest {
  name: string;
  description?: string;
  isActive?: boolean;

  eventDefinitionId: string;

  assetScope?: TriggerAssetScope;

  workflowId: string;
  /** Only required when assetScope === 'event'. */
  assignmentStrategy?: TriggerAssignmentStrategy;
  assigneeUserId?: string;
}

export interface UpdateTriggerRequest {
  name?: string;
  description?: string;
  isActive?: boolean;

  eventDefinitionId?: string;

  assetScope?: TriggerAssetScope;

  workflowId?: string;
  assignmentStrategy?: TriggerAssignmentStrategy;
  assigneeUserId?: string;
}

export const triggerService = {
  list: async (
    page = 1,
    pageSize = 50,
    filters?: TriggerFilters,
  ): Promise<PaginatedResponse<Trigger>> => {
    const params: Record<string, unknown> = { page, page_size: pageSize };
    if (filters?.search) params.search = filters.search;
    if (filters?.eventDefinitionId) params.event_definition_id = filters.eventDefinitionId;
    if (filters?.isActive !== undefined) params.is_active = filters.isActive;

    const response = await api.get<PaginatedResponse<Trigger>>('/triggers', { params });
    return response.data;
  },

  get: async (id: string): Promise<Trigger> => {
    const response = await api.get<Trigger>(`/triggers/${id}`);
    return response.data;
  },

  create: async (data: CreateTriggerRequest): Promise<Trigger> => {
    const response = await api.post<Trigger>('/triggers', data);
    return response.data;
  },

  update: async (id: string, data: UpdateTriggerRequest): Promise<Trigger> => {
    const response = await api.put<Trigger>(`/triggers/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/triggers/${id}`);
  },
};
